import { ALLOWED_MIME_TYPES, MAX_FILE_SIZE } from "../../helper";

export interface ValidateFilesMessages {
  invalidFile: (fileName: string) => string;
  fileTooLarge: (fileName: string, sizeMb: string) => string;
}

const defaultMessages: ValidateFilesMessages = {
  invalidFile: (fileName) => `Invalid file: ${fileName}`,
  fileTooLarge: (fileName, sizeMb) => `File too large: ${fileName} (${sizeMb} MB)`,
};

export const validateFilesWithErrors = (
  fileList: FileList | File[],
  allowedMimeTypes = ALLOWED_MIME_TYPES,
  maxFileSize = MAX_FILE_SIZE,
  messages: ValidateFilesMessages = defaultMessages
): { validFiles: File[]; errors: string[] } => {
  const files = Array.from(fileList || []);
  const errors: string[] = [];

  const validFiles = files.filter((file) => {
    const isValidType = allowedMimeTypes.includes(file.type);
    const isValidSize = file.size <= maxFileSize;

    if (!isValidType) {
      errors.push(messages.invalidFile(file.name));
    }
    if (!isValidSize) {
      errors.push(messages.fileTooLarge(file.name, (file.size / 1024 / 1024).toFixed(2)));
    }

    return isValidType && isValidSize;
  });

  return { validFiles, errors };
};

export const getReadableFileSize = (size: number): string => {
  if (size >= 1024 * 1024) {
    return (size / (1024 * 1024)).toFixed(2) + ' MB';
  } else if (size >= 1024) {
    return (size / 1024).toFixed(2) + ' KB';
  } else {
    return size + ' Bytes';
  }
};